// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"238":"33b50378","412":"f64c8ff7","823":"8a85c9c7","833":"02782c46","843":"09a96bc1","870":"615ce5c0","919":"cc7812e8","955":"7f88dd20"}[chunkId] + ".chunk.css";
};